module.exports = __webpack_public_path__ + "img/warning-icon.e69c8dae.svg";